import { DocumentDetails } from './DocumentDetails';

export class ClaimDocument {

    public documentType: string;
    public documents: DocumentDetails[];
    public mandatory: boolean;

    constructor(claimDocuments: any) {

        this.mandatory = claimDocuments.mandatory;
        this.documentType = claimDocuments.documentType;
        this.documents = [];
        if(claimDocuments.documents) {
            for (const doc of claimDocuments.documents) {
                this.documents.push(new DocumentDetails(doc));
            }
        }
    }

    /**
     * Getter $documentType
     * @return {string}
     */
    public get $documentType(): string {
        return this.documentType;
    }

    /**
     * Getter $documents
     * @return {DocumentDetails[]}
     */
    public get $documents(): DocumentDetails[] {
        return this.documents;
    }

    /**
     * Setter $documentType
     * @param {string} value
     */
    public set $documentType(value: string) {
        this.documentType = value;
    }

    /**
     * Setter $documents
     * @param {DocumentDetails[]} value
     */
    public set $documents(value: DocumentDetails[]) {
        this.documents = value;
    }

    /**
    * Getter $mandatory
    * @return {boolean}
    */
    public get $mandatory(): boolean {
        return this.mandatory;
    }


    /**
    * Setter $mandatory
    * @param {boolean} value
    */
    public set $mandatory(value: boolean) {
        this.mandatory = value;
    }


}
